module.exports = __webpack_public_path__ + "static/media/mockup-nc.71486500.png";